import { Modal } from 'bootstrap';

$(function () {
    $('#statistics-newsletter-form').on('submit', function (e) {
        e.preventDefault();
        const $this = $(this);
        if (!$this[0].checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
            $this[0].classList.add('was-validated');
            return;
        }
        const fullname = $('#txt-fullname');
        const organization = $('#txt-organization');
        const email = $('#txt-email');
        const domain = $('#domain').val();
        const btnSend = $('#btn-statistics-newsletter');
        btnSend.prop('disabled', true);
        btnSend.html('Enviando...');
        const modal = new Modal(document.getElementById('modal-statistics-newsletter'), {});
        const modalBody = $('#modal-statistics-newsletter-body');
        $.ajax({
            type: "POST",
            url: `${domain}/ajax`,
            data: `tipo=newsletter_subscribe&fullname=${encodeURIComponent(fullname.val())}&organization=${encodeURIComponent(organization.val())}&email=${encodeURIComponent(email.val())}`,
            success: function () {
                modalBody.html('<h3 class="text-center">¡Gracias por suscribirte!</h3>');
                modal.show();
                btnSend.html('Suscribirse');
                btnSend.prop('disabled', false);
                $this[0].classList.remove('was-validated');
                fullname.val('');
                organization.val('');
                email.val('');
            },
            error: function (jqXHR) {
                let message = 'Ha ocurrido un error. Por favor intenta de nuevo.';
                if (jqXHR.status === 409) {
                    message = 'Este correo ya está suscrito.';
                }
                modalBody.html(`<h3 class="text-danger text-center">${message}</h3>`);
                modal.show();
                btnSend.html('Suscribirse');
                btnSend.prop('disabled', false);
            },
            complete: function () {
                btnSend.prop('disabled', false);
            }
        });
    })
});